import { defineStore } from "pinia";
import { ref } from "vue";

export const useCurrSchedDataIdsStore = defineStore(
  "currSchedDataIdsStore",
  () => {
    // The current schedule is the one that was (last) selected from the select dropdown on the schedule page.
    const currSchedPeriodId = ref("");
    
    const currTeamId = ref("");
    const currUserIdForBidEdit = ref("");

    return {
      currSchedPeriodId,
      currTeamId,
      currUserIdForBidEdit,
    };
  },
);
